import i18n from "../i18n";

// -------------------------------
// 🌬️ Wind icon (static style)
// -------------------------------
export function getWindIcon() {
  return (
    <svg
      className="wind-icon"
      width="28"
      height="28"
      viewBox="0 0 64 64"
      aria-hidden="true"
    >
      <path
        d="M4 28h36c6 0 6-8 0-8"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M4 36h44c6 0 6 8 0 8"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M4 20h26c6 0 6-8 0-8"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}

// -------------------------------
// ➡️ Wind direction arrow
// -------------------------------
export function getWindArrow(deg, ariaLabel) {
  if (typeof deg !== "number") return null;

  return (
    <span
      className="wind-arrow"
      data-rotation={deg}
      style={{ "--wind-rotation": `${deg}deg` }}
      aria-label={
        ariaLabel ||
        i18n.t("weather_wind_direction_degrees", {
          defaultValue: "Wind direction {{deg}} degrees",
          deg,
        })
      }
    >
      <svg
        className="wind-arrow-svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        {/* Arrow body */}
        <path
          d="M12 22 V6"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />

        {/* Arrow head */}
        <path
          d="M12 2 L6 8 M12 2 L18 8"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

// -------------------------------
// 🌤️ Weather icon
// -------------------------------
export function getWeatherIconByKey(key) {
  switch (key) {
    case "clear":
      return "☀️";
    case "partly_cloudy":
      return "🌤️";
    case "cloudy":
      return "☁️";
    case "fog":
      return "🌫️";
    case "drizzle":
      return "🌦️";
    case "rain":
      return "🌧️";
    case "storm":
      return "⛈️";
    case "snow":
      return "❄️";
    default:
      return "🌡️";
  }
}

// -------------------------------
// 🌙 Moon icon
// -------------------------------
export function getMoonIcon(phase) {
  if (typeof phase !== "string") return "🌙";
  const p = phase.toLowerCase();

  if (p.includes("new")) return "🌑";
  if (p.includes("waxing crescent")) return "🌒";
  if (p.includes("first")) return "🌓";
  if (p.includes("waxing gibbous")) return "🌔";
  if (p.includes("full")) return "🌕";
  if (p.includes("waning gibbous")) return "🌖";
  if (p.includes("last")) return "🌗";
  if (p.includes("waning crescent")) return "🌘";
  return "🌙";
}

// -------------------------------
// 🌅 / 🌇
export const getSunriseIcon = () => "🌅";
export const getSunsetIcon = () => "🌇";

// -------------------------------
// 📉 Depth icon + direction
// -------------------------------
export function getDepthIcon(depth) {
  if (typeof depth !== "number") return "📉";
  return depth < 0 ? "📉⬇️" : "📉⬆️";
}

// -------------------------------
// 🌦 Normalize provider condition text → icon key
// -------------------------------
export function normalizeWeatherConditionKey(condition) {
  if (!condition || typeof condition !== "string") return null;

  const c = condition.toLowerCase();

  if (c.includes("clear") || c.includes("sun")) return "clear";
  if (c.includes("partly")) return "partly_cloudy";
  if (c.includes("cloud") || c.includes("overcast")) return "cloudy";
  if (c.includes("rain")) return "rain";
  if (c.includes("drizzle")) return "drizzle";
  if (c.includes("snow")) return "snow";
  if (c.includes("storm") || c.includes("thunder")) return "storm";
  if (c.includes("fog") || c.includes("mist")) return "fog";

  return null;
}
